import { getPreviewState } from './getPreviewState';
const ALLOWED_DFC_ERROR_FIELD_NAMES = new Set(['com_hubspot_portals_platform_app_rpc_AccessRpc_loginVerify', 'com_hubspot_portals_platform_app_rpc_NavigationRpc_getPortalNavigation']);

// brandData fetches are expected to fail while the portal is being previewed
// in the Theme Editor, so only suppress that error during preview sessions.
const PREVIEW_ONLY_ALLOWED_DFC_ERROR_FIELD_NAMES = new Set(['brandData']);
const MAX_WRAPPED_ERROR_DEPTH = 3;

// A `TypeError: Failed to fetch` means the browser never got a response: the
// buyer's connection dropped, they navigated away mid-request, or an extension
// blocked the request. Nothing is wrong with the portal, so it is not a useful
// JS error. The CHIRP client and Apollo each wrap the original failure, so walk
// the chain instead of only looking at the top-level error.
export const isFailedToFetchError = (error, depth = 0) => {
  if (!error || typeof error !== 'object' || depth > MAX_WRAPPED_ERROR_DEPTH) {
    return false;
  }
  if (error.name === 'AbortError' || error.name === 'TypeError' && ['Failed to fetch', 'Network request failed', 'NetworkError when attempting to fetch resource'].includes(error.message) || error.errorCode === 'NETWORKERROR' || error.errorCode === 'ABORT' || error.status === 0 && !error.errorCode) {
    return true;
  }
  return isFailedToFetchError(error.cause, depth + 1) || isFailedToFetchError(error.networkError, depth + 1);
};
export const isAllowedDfcError = (_reason, fieldName) => {
  if (ALLOWED_DFC_ERROR_FIELD_NAMES.has(fieldName)) {
    return true;
  }
  if (PREVIEW_ONLY_ALLOWED_DFC_ERROR_FIELD_NAMES.has(fieldName)) {
    return getPreviewState().isPreview;
  }
  return false;
};